import { render, staticRenderFns } from "./text-modal.vue?vue&type=template&id=ea099332&"
import script from "./text-modal.vue?vue&type=script&lang=js&"
export * from "./text-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports